import ENGRAVING_ACTION_TYPES from 'constants/engravingActionTypes';
import Engraving from 'models/Engraving';

const initialState = () => {
    return Engraving();
};

const engravingReducer = (state = initialState(), action) => {
    const { payload } = action;
    switch (action.type) {
        // Updates the booking
        case ENGRAVING_ACTION_TYPES.update: {
            // Gets the latest booking data from the localstorage
            let newState = {};
            newState = {
                ...state,
                ...payload
            };
            return newState;
        }

        // Updates the booking
        case ENGRAVING_ACTION_TYPES.clear:
            return Engraving();

        default:
            return state;
    }
};

export default engravingReducer;
